import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import moment from 'moment';
import axios from 'axios'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons'

import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

axios.defaults.headers.common['Access-Control-Allow-Origin'] = "*";
//axios.defaults.baseURL = 'http://localhost:8081/api/'
//axios.defaults.baseURL = 'https://creg075-dev.emcali.com.co/api/'
axios.defaults.baseURL = 'https://proyectoselectricosbk.emcali.com.co/api/'

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY HH:mm')
    }
}); 

Vue.component('v-icon', Icon)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
